<!--
=========================================================================================
  Message List Item
==========================================================================================
-->

<template>
  <div v-if="message" @click="selectMessage(message)">
    <!-- Custom View via Slot -->
    <div v-if="$slots.default" v-bind:message="message">
      <slot />
    </div>

    <!-- Default View -->
    <div
      v-else
      class="mail__mail-item sm:px-4 px-2 py-6"
      :class="{'mail__opened-mail': !message.unread}"
    >

      <!-- MESSAGE ROW 1 : META -->
      <div class="flex w-full">
        <vs-avatar
          class="sender__avatar flex-shrink-0 mr-3 border-2 border-solid border-white"
          :src="'http://files.xtrathai.com/' + message.senderUUID" size="40px" />

        <div class="flex w-full justify-between items-start">
            <div class="mail__details">

              <div class="mb-1 flex flex-inline justify-between">
                <h5 v-if="message.topic">
                  {{ message.topic }}</h5>
                <span v-else>
                  {{ $t('no-subject') }}
                </span>
                <vs-chip v-if="message.unread" transparent color="warning" class="ml-2 my-auto" style="min-height: 20px;">
                  <span>UNREAD</span>
                </vs-chip>

                <vs-chip v-if="!message.fromUser" transparent color="danger" class="ml-2 my-auto" style="min-height: 20px;">
                  <span>READ ONLY</span>
                </vs-chip>
              </div>

              <span class="mt-2 font-bold">{{ message.sender_name }}</span>
              <span class="mt-2 font-semibold"
                :class="{ '_auto_parentheses' : message.sender_name.replace(/\s/g, '') }" >{{ $t('general.code') }} {{ message.sender_code }}</span>
            </div>

            <div class="mail-item__meta flex items-center">
                <div class="email__labels hidden sm:flex items-center">
                  <div class="h-2 w-2 rounded-full mr-2"
                    :class="'bg-' + labelColor(label)"
                    v-for="(label, index) in message.labels" :key="index" />
                </div>
                <span>{{ message.time | date }}</span>
            </div>
        </div>
      </div>
      <!-- / MESSAGE ROW 1 -->

      <!-- MESSAGE ROW 2 : MSG & ACTIONS -->
      <div class="flex w-full">
        <div class="flex items-center ml-1">
          <vs-checkbox
            v-model="isSelectedMessage"
            @click.stop class="vs-checkbox-small ml-0 mr-1" />
          <feather-icon icon="StarIcon"
            class="cursor-pointer"
            :svgClasses="[{'text-warning fill-current stroke-current': message.isStarred}, 'w-5', 'h-5']"
            @click.stop="toggleIsStarred" />
        </div>
        <div class="mail__message truncate ml-3">
          <span>{{ message.content | filter_tags }}</span>
        </div>
          <div class="mb-1 flex flex-inline justify-between">
            <vs-chip v-if="message.subject" transparent color="success" class="ml-2 my-auto" style="min-height: 20px;">
              <span>
                {{ message.subjectCode }} {{ message.subjectName }}
              </span>
            </vs-chip>
          </div>
      </div>
      <!-- / MESSAGE ROW 2 -->
    </div>
  </div>
</template>

<script>
import { state } from "../data";

export default {
  props: {
    message: {
      type: Object,
      default: null
    },
    // isSelected: {
    //   type: Boolean,
    //   required: true,
    // }
  },
  data() {
    return {
      // isSelectedMessage: this.isSelected,
      localData: state.local,
    }
  },
  watch: {
    // isSelected(value) {
    //   this.isSelectedMessage = value
    // },
    /* isSelectedMessage(val) {
      val ? this.$emit('addToSelected', this.message.id) : this.$emit('removeSelected', this.message.id)
    } */
  },
  computed: {
    labelColor() {
      return (label) => {
        return label || "primary";
        // const tags = this.$store.state.emessage.mailTags
        // return tags.find((tag) => {
        //   return tag.value == label
        // }).color
      }
    },
  },
  methods: {
    // toggleIsStarred() {
      // const payload = { mailId: this.message.id, value: !this.message.isStarred }
      // this.$store.dispatch('email/toggleIsMailStarred', payload)
    // },
    selectMessage(message) {

      // Activate Message Content Pane.
      this.localData.isMessageContentActive = true;

      // Check if the selected message is already in the list, pop it out.
      const existMessageIndex = this.localData.currentViewingMessages.findIndex(m => m === message.id);
      if (existMessageIndex > -1) this.localData.currentViewingMessages.splice(existMessageIndex, 1);

      this.localData.currentViewingMessages.unshift(message.id);

      if (message.type) this.localData.currentViewingMessageType = message.type;

      // // Pop last message out, Store only latest 10.
      if (this.localData.currentViewingMessages.length > 10) this.localData.currentViewingMessages.pop();

      // // Set viewing cursor to position 0;
      this.localData.currentViewingMessageCursor = 0;

      // TODO: Set as read
      this.localData.currentTopic = message;

    },
    type() {
      return this.localData.currentViewingMessageType;
    }
  }
}
</script>

<style lang="scss">
._auto_parentheses {
  &::before {
    content: "\00a0\00a0 ("
  };
  &::after {
    content: ") "
  }
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.5px;
}
</style>
